import { PlatformAnalyticsSettings } from "@/features/analytics/PlatformAnalytics";
import { createFileRoute } from "@tanstack/react-router";
import { ShieldAlert } from "lucide-react";
import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react/macro";

import {
  CompanionHero,
  SurfaceHeader,
  SurfaceLayout,
} from "@ando/ui";

import {
  AccountDeletion,
  DataExport,
} from "@/features/settings";

/**
 * Settings → Privacy — GDPR Articles 15 + 17.
 *
 * Mounts two self-contained panels stacked vertically inside the standard
 * ``SurfaceLayout`` chrome (mirrors ``settings/security.tsx``):
 *
 *   - ``DataExport``     — kick off + poll the Article 15 export job.
 *   - ``AccountDeletion`` — typed-confirmation destructive Article 17 flow.
 *
 * Both call ``/api/v1/gdpr/*`` directly via the ``@ando/core`` ApiClient.
 */
function PrivacySettings() {
  const { i18n } = useLingui();
  return (
    <SurfaceLayout
      header={
        <SurfaceHeader
          label={i18n._(msg`Impostazioni`)}
          title={i18n._(msg`Privacy`)}
          meta={<span>{i18n._(msg`diritto d'accesso · diritto all'oblio`)}</span>}
        />
      }
      hero={
        <CompanionHero icon={<ShieldAlert size={14} strokeWidth={2} />}>
          {i18n._(
            msg`Strumenti GDPR self-service: esporta tutti i tuoi dati oppure richiedi la cancellazione definitiva dell'account.`,
          )}
        </CompanionHero>
      }
    >
      <div className="flex flex-col">
        <div className="px-8 py-4">
          <PlatformAnalyticsSettings />
        </div>
        <DataExport />
        <AccountDeletion />
      </div>
    </SurfaceLayout>
  );
}

export const Route = createFileRoute("/_authed/_modal/settings/privacy")({
  component: PrivacySettings,
});
